<template>
  <w-row v-bind="$props">
    <slot />
  </w-row>
</template>

<script>
import WorkRow from "../grid/WorkRow";

export default {
  name: "WorkDividedInWrapperRow",
  props: {
    ...WorkRow.props,
    dense: { type: Boolean, default: true }
  },
}
</script>
